import { Box, styled } from '@mui/material'

// DataGrid descendant styling lives in the omui MuiDataGrid theme override
// (apps/frontend/shared/omui/src/theme2/components/MuiDataGrid.ts).
// This wrapper only sizes the layout.
export const DataGridContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'maxHeight',
})<{ maxHeight?: string }>(({ maxHeight }) => ({
  flexGrow: 1,
  height: '100%',
  maxHeight: maxHeight ?? '100%',
  ...(maxHeight != null && { display: 'flex', flexDirection: 'column' }),
}))
